import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Table, Button, Switch, Modal, Checkbox, message, Form, Steps } from 'antd';
// import { LeftOutlined } from '@ant-design/icons';
import PageHeader from '@components/PageHeader/PageHeader';

import { fetchCasescoringtopicsList, putCasescoringtopicsUpdate, fetchProjecttopicsList, saveProjecttopicsList } from '@services/Selection';
import ExportPCRankingDrawer from './components/ExportPCRankingDrawer';
import ExportH5RankingDrawer from './components/ExportH5RankingDrawer';
import { workspaceSelectionReviewAssignPath, workspaceSelectionReviewCasesPath, workspaceSelectionReviewResetAssignPath, workspaceSelectionReviewScoringSettingsPath } from '@/layouts/selectionWorkspacePaths';

import './index.less';
import dayjs from 'dayjs';
const handleTopicsSouce = ({ topicSource = [], dataSource = [] }) => {
    const idMap = {};
    dataSource.forEach(i => {
        idMap[i.topicId] = i.topicId;
    });
    return topicSource.filter(item => !idMap[item.value]);
};

const getColumns = ({ params, navigate, handleChangeSwitch }) => [
    {
        title: '主题',
        dataIndex: 'topicName',
        align: 'center',
    },
    {
        title: '实践数',
        dataIndex: 'caseTotal',
        align: 'center',
    },
    {
        title: '分配专家数',
        dataIndex: 'judgesTotal',
        align: 'center',
    },
    {
        title: '评议起止时间',
        key: 'id',
        align: 'center',
        render: row => {
            return `${row.scoringStartedAt ? dayjs(row.scoringStartedAt).format('YYYY-MM-DD HH:mm') : ''} - ${row.scoringEndedAt ? dayjs(row.scoringEndedAt).format('YYYY-MM-DD HH:mm') : ''}`;
        },
    },
    {
        title: '展示状态',
        key: 'id',
        align: 'center',
        render: (row, _, _i) => {
            return <Switch checkedChildren="显示" unCheckedChildren="隐藏" checked={!row.hidden} onChange={e => handleChangeSwitch(e, row.id)} />;
        },
    },
    {
        title: '操作',
        key: 'id',
        align: 'center',
        render: row => {
            return (
                <React.Fragment>
                    <Button type="link" onClick={() => navigate(workspaceSelectionReviewScoringSettingsPath(params.pid, params.id, row.id), { state: { ...row.scoringSetting, projectName: row.projectName, stageName: row.stageName, topicName: row.topicName } })}>
                        评议规则设置
                    </Button>
                    <Button
                        type="link"
                        onClick={() => {
                            navigate(workspaceSelectionReviewCasesPath(params.pid, params.id, row.topicId), {
                                state: { decimalPlaceNum: row?.scoringSetting?.decimalPlaceNum, caseFinalScoreDecimalPlaceNum: row?.scoringSetting?.caseFinalScoreDecimalPlaceNum, projectName: row.projectName, stageName: row.stageName, topicName: row.topicName },
                            });
                        }}
                    >
                        评议实践管理
                    </Button>
                </React.Fragment>
            );
        },
    },
];

const ScoreStageTopicList = () => {
    const params = useParams();
    const [form] = Form.useForm();
    const dataRef = useRef({ dataSource: [], topicSource: [] });
    const [dataSource, setDataSource] = useState([]);
    const [topicSource, setTopicSource] = useState([]);
    const [topicModal, setTopicModal] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const [h5DrawerVisible, setH5DrawerVisible] = useState(false);
    const [pcDrawerVisible, setPcDrawerVisible] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        dataRef.current = { dataSource: dataSource, topicSource: topicSource };
    }, [dataSource, topicSource]);

    const fetchList = useCallback(
        (needLoading = true) => {
            if (needLoading) {
                setTableLoading(true);
            }
            fetchCasescoringtopicsList({ projectId: params.pid, stageId: params.id })
                .then(result => {
                    if (result?.status_code === 200) {
                        setDataSource(result.data || []);
                    }
                })
                .finally(() => {
                    setTableLoading(false);
                });
        },
        [params],
    );

    useEffect(() => {
        fetchList();
        fetchProjecttopicsList({ projectId: params.pid }).then(result => {
            if (result?.status_code === 200) {
                const list = [],
                    data = result.data;
                for (let i = 0; i < data.length; i++) {
                    const element = data[i];
                    if (element?.children?.length) {
                        list.push(...element.children.map(item => ({ label: item.name, value: item.id, ...element })));
                    } else if (element.pid === 0) {
                        list.push({ label: element.name, value: element.id, ...element });
                    }
                }
                setTopicSource(list);
            }
        });
    }, [fetchList, params]);

    useEffect(() => {
        document.title = '评分实践-医评议';
    }, []);

    const columns = useMemo(() => {
        const handleChangeSwitch = (value, id) => {
            putCasescoringtopicsUpdate({ hidden: value ? 0 : 1, id }).then(res => {
                if (res?.status_code === 200) {
                    message.success('修改成功！');
                    fetchList();
                }
            });
        };

        return getColumns({ params, navigate, handleChangeSwitch });
    }, [fetchList, navigate, params]);

    const header = useMemo(() => {
        const handleAddTopic = () => {
            const topics = handleTopicsSouce(dataRef.current);
            if (!topics.length) {
                return message.warning('无待添加评议主题！');
            }
            setTopicSource(topics);
            setTopicModal(true);
        };

        const goToAssign = () => {
            navigate(workspaceSelectionReviewAssignPath(params.pid, params.id));
        };

        const goToResetAssign = () => {
            navigate(workspaceSelectionReviewResetAssignPath(params.pid, params.id));
        };

        return (
            <div className="mark-table-header">
                <div className="mark-table-header-button">
                    <Button type="primary" onClick={handleAddTopic}>
                        添加评议主题
                    </Button>
                    <Button onClick={goToAssign}>分配专家任务</Button>
                    <Button onClick={goToResetAssign}>重置专家任务</Button>
                </div>
                <div className="mark-table-header-button">
                    <Button onClick={() => setH5DrawerVisible(true)}>导出H5结果图</Button>
                    <Button onClick={() => setPcDrawerVisible(true)}>导出PC结果图</Button>
                </div>
            </div>
        );
    }, [navigate, params.id, params.pid]);

    const onOk = () => {
        const topicIds = form.getFieldValue('topics');

        if (topicIds?.length) {
            setConfirmLoading(true);
            saveProjecttopicsList({ projectId: params.pid, stageId: params.id, topicIds })
                .then(res => {
                    if (res?.status_code === 200) {
                        fetchList();
                        message.success('添加成功！');
                        setTopicModal(false);
                        form.resetFields();
                    } else {
                        message.warning('添加失败，请重试！');
                    }
                })
                .finally(() => {
                    setConfirmLoading(false);
                });
        }
    };

    return (
        <>
            <PageHeader breadcrumb={[]}>
                <span className="back" onClick={() => navigate(-1)}>
                    <i className="bi bi-chevron-left" />
                </span>
                <span className="current-title">评议实践</span>
                <span className="current-subtitle wrap-subtitle">
                    {location.state?.projectName}
                    <br />
                    {location.state?.stageName}
                </span>
            </PageHeader>

            <div className="page-route-body mark-table-content">
                <div className="step-container">
                    <Steps current="0" titlePlacement="vertical" items={[{ title: '添加评议主题' }, { title: '评议规则设置' }, { title: '评议实践管理' }, { title: '分配专家任务' }]} />
                </div>

                <Table dataSource={dataSource} columns={columns} rowKey="id" title={() => header} pagination={false} loading={tableLoading} />
            </div>

            <Modal centered width={600} title="选择评议主题" open={topicModal} confirmLoading={confirmLoading} onOk={onOk} onCancel={() => setTopicModal(false)} afterClose={() => setTopicModal(false)}>
                <Form form={form}>
                    <Form.Item
                        name="topics"
                        label="评议主题"
                        labelCol={{
                            sm: { span: 8 },
                        }}
                        wrapperCol={{
                            sm: { offset: 1 },
                        }}
                    >
                        <Checkbox.Group options={topicSource} className="pingwei-checkgroup" />
                    </Form.Item>
                </Form>
            </Modal>

            <ExportH5RankingDrawer open={h5DrawerVisible} onClose={() => setH5DrawerVisible(false)} title="预览H5荣誉结果图" projectInfo={{ ...location.state, projectId: params.pid, stageId: params.id }} />

            <ExportPCRankingDrawer open={pcDrawerVisible} onClose={() => setPcDrawerVisible(false)} title="预览PC荣誉结果图" projectInfo={{ ...location.state, projectId: params.pid, stageId: params.id }} />
        </>
    );
};

export default ScoreStageTopicList;
